import React from 'react';

const SrH1 = ({ children }) => <div className="SrH1">{children}</div>;

SrH1.displayName = 'SrH1';

export default SrH1;
